/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import "./adminTest.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { clearErrors } from "../../../ActionCreators/errorAction";
import { getQuestionFromSkill, addQuizQuestions, selectQuestions } from '../../../ActionCreators/AdminAction/adminTestAction';
import Snackbar from '@mui/material/Snackbar';
import Select, { components } from 'react-select'
import Feedpopup from '../../Feeds-popup/feedpopup';
import $ from 'jquery';

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};

function Questions(props) {
    const [query, setQuery] = useState('');
    const [skill, setSkill] = useState('');
    const [selectSkill, setSelectSkill] = useState('');
    const [selectType, setSelectType] = useState('');
    const [isView, setIsView] = useState(false);
    const [resource, setResource] = useState(null);

    useEffect(() => {
        setSkill(props.skill);
        setSelectSkill(props.skill?.value);
        setSelectType(props.selectType);
        props.selectType &&
            props.getQuestionFromSkill(props.skill?.value);
    }, [])


    const onQuestionSelect = (e, question) => {
        if (e.target.checked === true) {
            props.addQuizQuestions(question);
        } else {
            props.selectQuestions(question._id);
        }
    };

    const getSkill = (e) => {
        setSkill(e);
        setSelectSkill(e.value);
        props.getQuestionFromSkill(e.value);

    }

    const serachQuestions = (e) => {
        setQuery(e.target.value);
    };





    const viewQuestion = async (type, details) => {
        console.log(details)
        // await props.getQuestionForEdit(type, id);
        await setIsView(true);
        await setResource({ ...details, type1: 'Question' });
        $("body").css("overflow", "hidden");
    }

    const closeDetails = () => {
        setIsView(false);
        setResource('');
        $("body").css("overflow", "visible");
    }



    const snackClosed = () => {
        props.clearErrors();
    }

    const { questionListForQuiz, questions, type } = props;
    const updatedquestionList = questions && questions.map((question) => {
        if (questionListForQuiz && questionListForQuiz?.findIndex((element) => element._id === question._id) !== -1) {
            return {
                ...question,
                checked: true,
            };
        }
        return { ...question, checked: false };
    });
    return (
        <Fragment>

            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={props.successMessage}
                onClose={() => snackClosed()}
                message={props.successMessageText}
                autoHideDuration={4000}
            />
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={props.successEnable}
                onClose={() => snackClosed()}
                message={props.successMessageText}
                autoHideDuration={4000}
            />

            <div
                className={
                    type === "selectQuestion"
                        ? ("ques-list selected-ques")
                        : "ques-list"
                }
            >
                <Fragment>
                    <div className='ques-header'>
                        {
                            type === "selectQuestion" ? (
                                <div className="select" style={{ fontSize: 20, cursor: "pointer" }}>
                                    <div className="d-flex align-items-center select-ques">
                                        <p style={{ marginTop: 5 }} onClick={() => props.backToMain()}>
                                            <img src="/images/back1.svg" alt="" width="20px" />
                                        </p>
                                        &nbsp; &nbsp;
                                        <h1 style={{ color: '#222222' }}>Select question</h1>
                                        <button className="ml-auto" onClick={() => props.backToMain()}>
                                            Done <span class="arrow-right"></span>
                                        </button>
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>
                    <div className="content-header" style={{ marginTop: 2, padding: 10 }}>
                        <div className="content-heading">
                            {type === "selectQuestion" ? (
                                <div className="d-flex align-items-center search-input">
                                    <div className='position-relative'>
                                        <div class="symbol">
                                            <img src="/images/search.svg" alt="" width='14px' />
                                        </div>
                                        <input
                                            style={{ height: 40 }}
                                            className='form-control'
                                            autoComplete="off"
                                            placeholder="Search for a question or tags"
                                            spellCheck="false"
                                            onChange={(e) => serachQuestions(e)}
                                            type="text"
                                        />
                                    </div>
                                    &nbsp;&nbsp;
                                    <div style={{ width: '30%' }}>
                                        <Select
                                            components={{ DropdownIndicator }}
                                            options={props.skillList.map(el => [{ label: el.title, value: el._id }][0])}
                                            onChange={getSkill}
                                            placeholder='Select skill'
                                            value={skill}
                                        />
                                    </div>
                                    <div className="ml-auto">
                                        <h2 >{questionListForQuiz?.length}</h2>
                                        <span style={{ fontSize: 12, color: '#9B9AA3', marginLeft: -10 }}>Questions Selected</span>
                                    </div>
                                </div>
                            ) : null}

                            <ul className="select-ques-table">
                                <li>
                                    <div className="first-row">
                                        {" "}
                                        {type === "selectQuestion" ? "Select" : "Question #"}
                                    </div>
                                    <div style={{ width: "20%" }}>Type</div>
                                    <div style={{ width: "18%" }}>Tags</div>
                                    <div style={{ width: "37%" }}>Title</div>
                                    <div>Actions</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* {questions !== undefined && questions !== null ? ( */}
                    <ul className="program-list select-ques-table">
                        {type !== "selectQuestion" &&
                            questionListForQuiz &&
                            questionListForQuiz.length <= 0 ? (
                            <div className="empty-list">
                                <img src="/images/empty.png" alt="" />
                                <p>You have not added any Questions yet.</p>
                            </div>
                        ) : type !== "selectQuestion" && questionListForQuiz ? (
                            questionListForQuiz.filter(item => {
                                if (item.type !== 'Subjective') {
                                    if (!query) return true

                                    const regex = new RegExp(query, "i");
                                    return regex.test(item.title);
                                }
                                return false
                            }).map((el, index) => {
                                return (
                                    <li>
                                        <div className="program-name first-row">
                                            {type === "selectQuestion" ? (
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        onClick={(e) => {
                                                            onQuestionSelect(e, el);
                                                        }}
                                                        style={{ width: 20, height: 20 }}
                                                    />
                                                </td>
                                            ) : (
                                                <p>{index + 1}</p>
                                            )}
                                        </div>

                                        <div
                                            className="program-name text-center"
                                            style={{ width: "19%" }}
                                        >
                                            <p className='ml-0'>{el.type}</p>
                                        </div>
                                        <div
                                            className="program-name text-center"
                                            style={{ width: "20%" }}
                                        >
                                            <p><a title={el.tags !== undefined && el.tags.map(e => e).join(', ')} >{el.tags !== undefined && el.tags.slice(0, 2).map(e => e).join(' , ')} {el.tags !== undefined && el.tags?.length > 2 ? <p>+{el.tags?.length - 2}</p> : null}</a></p>
                                        </div>
                                        <div style={{ width: "37%" }}>
                                            <p dangerouslySetInnerHTML={{ __html: el.title }} />
                                        </div>

                                        {type === "selectQuestion" ?
                                            <div
                                                className="text-center"
                                                onClick={() => viewQuestion('Question', el)}
                                            >
                                                <img src="/images/view-icon.svg" alt="" width='25px' />
                                                &nbsp;&nbsp;
                                            </div>
                                            : (
                                                <div
                                                    className="text-center"
                                                    onClick={() => props.selectQuestions(el._id)}
                                                >
                                                    <img src="/images/delete.svg" alt="" />
                                                    &nbsp;&nbsp;
                                                </div>
                                            )}
                                    </li>
                                );
                            })
                        ) : updatedquestionList && updatedquestionList?.length ? (
                            updatedquestionList !== undefined &&
                            updatedquestionList.filter(item => {
                                if (item.type !== 'Subjective') {
                                    if (!query) return true

                                    const regex = new RegExp(query, "i");
                                    return regex.test(item.title);
                                }
                                return false
                            }).map((el, index) => {
                                return (
                                    <li>
                                        <div className="program-name ">
                                            {type === "selectQuestion" ? (
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={el.checked ? true : false}
                                                        onChange={(e) => {
                                                            onQuestionSelect(e, el);
                                                        }}
                                                        style={{ width: 20, height: 20 }}
                                                    />
                                                </td>
                                            ) : (
                                                <p>{index + 1}</p>
                                            )}
                                        </div>

                                        <div
                                            className="program-name text-center"
                                            style={{ width: "15%" }}
                                        >
                                            <p className='ml-0'>{el.type}</p>
                                        </div>
                                        <div
                                            className="program-name text-center"
                                            style={{ width: "20%" }}
                                        >
                                            <p><a title={el.tags !== undefined && el.tags.map(e => e).join(', ')} >{el.tags !== undefined && el.tags.slice(0, 2).map(e => e).join(' , ')} {el.tags !== undefined && el.tags?.length > 2 ? <p>+{el.tags?.length - 2}</p> : null}</a></p>
                                        </div>
                                        <div style={{ width: "37%" }}>
                                            <p dangerouslySetInnerHTML={{ __html: el.title }} />
                                        </div>

                                        {type === "selectQuestion" ?
                                            <div
                                                className="text-center"
                                                onClick={() => viewQuestion('Question', el)}
                                            >
                                                <img src="/images/view-icon.svg" alt="" width='25px' />
                                                &nbsp;&nbsp;
                                            </div>
                                            : (
                                                <div className="text-center">
                                                    <img src="/images/delete.svg" alt="" />
                                                    &nbsp;&nbsp;
                                                </div>
                                            )}
                                    </li>
                                );
                            })
                        ) : (
                            <div className="empty-list">
                                <img src="/images/empty.png" alt="" />
                                <p>You have not added any Questions yet.</p>
                            </div>
                        )}

                    </ul>
                </Fragment>
            </div>
            <div className="feeds-details" style={{ display: isView ? 'block' : 'none', }}>
                <Feedpopup
                    activeFeedData={resource}
                    closePopup={closeDetails}
                />
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => {
    const { questions, questionListForQuiz, questionData } = state.adminTest;
    const { successMessageText, successMessage, successEnable } = state.error;
    return {
        questions, questionData, questionListForQuiz,
        successEnable, successMessage, successMessageText,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getQuestionFromSkill, addQuizQuestions, selectQuestions,
        clearErrors,
        // getQuestionList, addQuizQuestions, , getQuestionFilterList, getQuestionForEdit
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Questions);
